import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase/config";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import BookSearchCarousel from "../components/BookSearchCarousel";

export default function AddBook() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [selectedBook, setSelectedBook] = useState(null);
  const [totalPages, setTotalPages] = useState("");
  const [targetDate, setTargetDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [bookStatus, setBookStatus] = useState("active");

  function handleSelect(book) {
    setSelectedBook(book);
    setTotalPages(book.pages || "");
  }

  function handleClear() {
    setSelectedBook(null);
    setTotalPages("");
  }

  async function handleSubmit() {
    if (!selectedBook) return alert("Please search for and select a book.");
    if (!totalPages) return alert("Please enter the total number of pages.");
    setLoading(true);
    try {
      await addDoc(collection(db, "books"), {
        userId: currentUser.uid,
        title: selectedBook.title,
        author: selectedBook.author,
        coverUrl: selectedBook.coverUrl || null,
        publisher: selectedBook.publisher || "",
        year: selectedBook.year || "",
        totalPages: parseInt(totalPages),
        pagesRead: 0,
        currentPage: 0,
        targetDate: targetDate || null,
        status: bookStatus,
        sessions: [],
        createdAt: new Date()
      });
      navigate("/");
    } catch {
      alert("Failed to add book. Try again.");
    }
    setLoading(false);
  }

  return (
    <div style={styles.container}>
      <Header />

      <div style={styles.content}>
        <div style={styles.card}>
          <h2 style={styles.sectionTitle}>Search for your book</h2>
          <BookSearchCarousel
            onSelect={handleSelect}
            selectedBook={selectedBook}
            onClear={handleClear}
          />
        </div>

        <div style={styles.card}>
          <h2 style={styles.sectionTitle}>How do you want to add this?</h2>
          <div style={styles.statusToggle}>
            <button
              type="button"
              style={bookStatus === "active" ? styles.toggleActive : styles.toggleInactive}
              onClick={() => setBookStatus("active")}
            >
              📖 Start Reading Now
            </button>
            <button
              type="button"
              style={bookStatus === "queue" ? styles.toggleActive : styles.toggleInactive}
              onClick={() => setBookStatus("queue")}
            >
              📚 Add to Queue
            </button>
          </div>
        </div>

        <div style={styles.card}>
          <h2 style={styles.sectionTitle}>Reading Goal</h2>
          <label style={styles.label}>Total Pages</label>
          <input
            style={styles.input}
            type="number"
            placeholder="How many pages is this book?"
            value={totalPages}
            onChange={(e) => setTotalPages(e.target.value)}
          />
          {bookStatus === "active" && (
            <>
              <label style={styles.label}>Target Finish Date (optional)</label>
              <input
                style={styles.input}
                type="date"
                value={targetDate}
                onChange={(e) => setTargetDate(e.target.value)}
              />
              <p style={styles.hint}>
                No date? No problem — we'll estimate based on your reading pace.
              </p>
            </>
          )}
        </div>

        <button style={styles.submitBtn} onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add Book"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: "100vh", backgroundColor: "#f0f4f8" },
  content: { padding: 24, maxWidth: 600, margin: "0 auto" },
  card: { backgroundColor: "white", borderRadius: 12, padding: 24, marginBottom: 16, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" },
  sectionTitle: { fontSize: 18, color: "#2d3748", marginTop: 0, marginBottom: 16 },
  input: { width: "100%", padding: 12, borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 16, boxSizing: "border-box", marginBottom: 12 },
  label: { display: "block", fontWeight: "bold", color: "#4a5568", marginBottom: 6, fontSize: 14 },
  hint: { color: "#a0aec0", fontSize: 13, margin: "8px 0 0 0" },
  submitBtn: { width: "100%", padding: 16, backgroundColor: "#48bb78", color: "white", border: "none", borderRadius: 8, fontSize: 18, cursor: "pointer" },
  statusToggle: { display: "flex", gap: 12 },
  toggleActive: { flex: 1, padding: 12, backgroundColor: "#4299e1", color: "white", border: "none", borderRadius: 8, fontSize: 15, cursor: "pointer", fontWeight: "bold" },
  toggleInactive: { flex: 1, padding: 12, backgroundColor: "#e2e8f0", color: "#4a5568", border: "none", borderRadius: 8, fontSize: 15, cursor: "pointer" },
};